import { cn } from '@/lib/utils';
import { Card } from '../card';
import { Skeleton } from '../Skeleton';
import { ShapeGroup } from './ShapeGroup';

const LINE_WIDTHS = ['70%', '55%', '40%', '60%'];

interface CardGridSkeletonProps {
  count?: number;
  /** Text lines under the title line. Default 3. */
  lines?: number;
  /** Grid classes. Default the event lists' 1 / 2 / 3 columns. */
  columns?: string;
  label?: string;
  className?: string;
}

/** A grid of cards (events, score-choice options): a title line over a few text lines. */
export function CardGridSkeleton({
  count = 6,
  lines = 3,
  columns = 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3',
  label,
  className,
}: CardGridSkeletonProps) {
  return (
    <ShapeGroup label={label} className={cn('grid gap-6', columns, className)}>
      {Array.from({ length: count }, (_, i) => (
        <Card key={i} data-skeleton-card="">
          <div className="space-y-3 p-4 sm:p-5">
            <Skeleton.Line width="40%" className="h-4" />
            {Array.from({ length: lines }, (_, l) => (
              <Skeleton.Line key={l} width={LINE_WIDTHS[l % LINE_WIDTHS.length]} />
            ))}
          </div>
        </Card>
      ))}
    </ShapeGroup>
  );
}
